import Parse from "parse";
export async function createNotification({
  type,
  description,
  description_pro,
  questionnaireId = null,
  meetingId = null,
  showToast = false,
  vueInstance,
  visibility = "both", // "patient", "therapist", "both", "none"
  toastType = "is-success", // 👈 AJOUT ICI
}) {
  console.log("%cCreateNotification :", "color: orange;", type, description, showToast, vueInstance);

  const currentUser = Parse.User.current();
  if (!currentUser) throw new Error("Utilisateur non connecté");

  const userGroup = currentUser.get("group");
  if (!userGroup?.id) throw new Error("Le groupe de l'utilisateur est introuvable");

  const isTherapist = currentUser.get("therapeute") === true;
  const therapist = isTherapist ? null : await getTherapistByGroup(userGroup.id);
  if (!isTherapist && !therapist) throw new Error("Aucun thérapeute trouvé pour ce groupe");

  const Notification = Parse.Object.extend("notification");
  const notification = new Notification();

  notification.set("type", type);
  notification.set("description", description);
  notification.set("description_pro", description_pro);
  notification.set("date_event", new Date());
  notification.set("isReadUser", false);
  notification.set("isReadUserPro", false);
  notification.set("visibility", visibility);

  // Détermine qui doit recevoir la notification selon la visibilité
  let patient = null;
  if (vueInstance?.$IdPatient) {
    const Patient = Parse.Object.extend("_User");
    patient = new Patient();
    patient.id = vueInstance.$IdPatient;
  }

  // Par défaut, le patient est le currentUser si non thérapeute
  if (!isTherapist && !patient) {
    patient = currentUser;
  }
  notification.set("user", patient || null);
notification.set("user_pro", therapist || null);

  if (questionnaireId) {
    const questionnaire = await getQuestionnaireById(questionnaireId);
    if (questionnaire) {
      notification.set("questionnaire_event", questionnaire);
    } else {
      throw new Error("Le questionnaire spécifié est introuvable");
    }
  }

  if (meetingId) {
    const meeting = await getMeetingById(meetingId);
    if (meeting) {
      notification.set("meeting_event", meeting);
    } else {
      throw new Error("Le rendez-vous spécifié est introuvable");
    }
  }

  console.log("%cSauvegarde de la notification... :", "color: orange;", notification);
  if (visibility === "none") {
    if (showToast && vueInstance) {
      vueInstance.$nextTick(() => {
        vueInstance.$buefy.toast.open({
          message: description,
          type: toastType,
          duration: 5000,
        });
      });
    }
    return; // Ne pas enregistrer en base
  }
  if (visibility === "therapist") {
  //notification.unset("user"); // 💥 important : supprime explicitement l'assignation côté patient
}
  await notification.save();
  console.log("%cNotification sauvegardée :", "color: orange;", notification);

  if (showToast && vueInstance) {
    vueInstance.$nextTick(() => {
      vueInstance.$buefy.toast.open({
        message: description,
        type: toastType,
        duration: 5000,
      });
    });
  }
}

/**
 * Recherche le thérapeute associé à un groupe
 */
async function getTherapistByGroup(groupId) {
  const groupQuery = new Parse.Query("user_group");
  groupQuery.equalTo("objectId", groupId);

  const therapistQuery = new Parse.Query(Parse.User);
  therapistQuery.matchesQuery("group", groupQuery);
  therapistQuery.equalTo("therapeute", true);

  return await therapistQuery.first();
}

/**
 * Recherche un questionnaire par son ID
 */
async function getQuestionnaireById(questionnaireId) {
  try {
    const Questionnaire = Parse.Object.extend("questionnaire");
    const questionnaireQuery = new Parse.Query(Questionnaire);
    return await questionnaireQuery.get(questionnaireId);
  } catch (error) {
    console.error("Erreur lors de la récupération du questionnaire :", error);
    return null;
  }
}

/**
 * Recherche un meeting par son ID
 */
async function getMeetingById(meetingId) {
  try {
    const Meeting = Parse.Object.extend("meeting");
    const meetingQuery = new Parse.Query(Meeting);
    return await meetingQuery.get(meetingId);
  } catch (error) {
    console.error("Erreur lors de la récupération du meeting :", error);
    return null;
  }
}